// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 945 ? "dashboard" : chunkId) + "." + {"945":"0cc406aa","7066":"270205d0"}[chunkId] + ".css";
};